import React, { useEffect, useState } from "react";
import { Button, Col, Container, Dropdown, Row } from "react-bootstrap";
import { generatePath, Link, useLocation, useNavigate, useParams } from "react-router-dom";
import AddNewGoalPop from "components/Modals/AddNewGoal";
import TableLayout from "components/TableLayout";
import {
  useGetGoalsStepDetailQuery,
  useSubmitGoalsStepMutation,
} from "store/services/clients/assessmentTreatmentPlan";
import {
  CheckIcon,
  CloseIcon,
  DeleteIcon,
  DownArrowIcon,
  DuplicateIcon,
  EditCricleIcon,
  HeartIcon,
  PlusCircleIcon,
} from "Assets/icons";
import LoadingOverlay from "components/shared/LoadingOverlay";
import ErrorComponent from "components/shared/ErrorComponent";
import LoadingIndicator from "components/shared/LoadingIndicator";
import LoadingButton from "components/shared/LoadingButton";
import {
  confirmMsg,
  dateFormat,
  printNameInitials,
  successMessageToast,
  userFullName,
  userFullNameReverse,
} from "helpers/common";
import { useDeleteGoalMutation } from "store/services/clients/assessmentTreatmentPlan/goals/manageGoals";
import { getFirstGuardian } from "helpers/clients";
import ConfirmationPop from "components/Modals/ConfirmationPop";

const ManageGoals = ({ onSubmit, onNavigateBack, previousUrl }) => {
  const navigate = useNavigate();

  const { assessmentId, clientId, clientType } = useParams();

  const [newGoalPopup, setNewGoalPopup] = useState(newGoalPopupState);
  const [editTreatmentName, setEditTreatmentName] = useState(false);
  const [treatmentName, setTreatmentName] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentItem, setCurrentItem] = useState(null);

  const { data, isLoading, isFetching, isError, refetch } = useGetGoalsStepDetailQuery({ assessmentId, clientId, clientType });
  const caseDiscipline = data?.clientPendingCaseload?.clientCaseloadTherapist?.caseDiscipline;
  const assessmentGoals = data?.assesmentData?.reportGoals;
  const assessmentAssignedId = data?.assesment?.id;
  const teacherDetails = getFirstGuardian(data?.client_detail?.client_guardian_mapping, "teacher");
  const parentDetails = getFirstGuardian(data?.client_detail?.client_guardian_mapping, "parent");

  const [submitStep, { isLoading: submitLoading }] = useSubmitGoalsStepMutation();
  const [deleteGoal, { isLoading: deleteGoalLoading }] = useDeleteGoalMutation();

  useEffect(() => {
    if (data?.assesment?.treatment_name) {
      // setTreatmentName(data?.assesment?.treatment_name);
      setTreatmentName(typeof data.assesment.treatment_name === "object" ? 'Report' : data?.assesment?.treatment_name)  
    }
  }, [data]);

  const hideNewGoalPopup = () => setNewGoalPopup(newGoalPopupState);

  const openNewGoalPopup = (data) => {
    setNewGoalPopup({
      show: true,
      editId: data?.id || null,
      data: data || null,
    });
  };

  const handleTreatmentNameChange = (e) => {
    setTreatmentName(e.target.value);
  };

  const handleSubmitStep = async () => {
    try {
      let payload = {
        treatment_name: treatmentName || '--',
      };

      let response = await submitStep({
        assessmentAssignedId,
        data: payload,
        clientType
      });
      onSubmit(response);
    } catch (err) {
      console.error("Error submitting step", err);
    }
  };

  const handleDeleteGoal = async () => {
    try {

      setShowDeleteModal(false);
      let response = await deleteGoal({ goalId: currentItem?.id, clientType });
      if (response?.data?.message) {
        successMessageToast(response?.data?.message);
        refetch();
      }
    } catch (err) {
      console.error("Error deleting goal", err);
    }
  };

  const column = [
    {
      head: "Name",
      accessor: "Name",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold">{item.assesmentGoalDetail?.title}</h6>
      ),
    },
    {
      head: "Context",
      accessor: "context",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold">{item.assesmentGoalContext?.context || "--"}</h6>
      ),
    },
    {
      head: "Discipline",
      accessor: "discipline",
      isComponent: true,
      component: (item, ind) => (
        <h6 className="m-0 fw-bold">{item.assesmentGoalDiscipline?.assign_term || "--"}</h6>
      ),
    },
    // {
    //   head: "Status",
    //   accessor: "Status",
    //   isComponent: true,
    //   component: (item, ind) => {
    //     let status = item?.assesmentGoalStatus?.title;
    //     return (
    //       <p
    //         className={`${
    //           status == "Complete"
    //             ? "greenStatus"
    //             : status == "Pending"
    //             ? "redStatus"
    //             : status == "Progressing"
    //             ? "blueStatus"
    //             : ""
    //         } status text-capitalize m-0 rounded-pill px-3 py-1 border fw-sbold d-inline-flex`}
    //       >
    //         {status}
    //       </p>
    //     );
    //   },
    // },
    {
      head: "Action",
      accessor: "",
      isComponent: true,
      component: (item) => (
        <div className="ActnBtn d-flex align-items-center  gap-10">
          {/* <Button
            variant="transparent"
            className="border-0 p-0 shadow rounded-circle"
          >
            <DuplicateIcon />
          </Button> */}
          <Button
            variant="transparent"
            className="border-0 p-0 shadow rounded-circle"
            onClick={() => openNewGoalPopup(item)}
          >
            <EditCricleIcon />
          </Button>
          <Button
            variant="transparent"
            className="border-0 p-0 shadow rounded-circle"
            onClick={() => {
              setCurrentItem(item);
              setShowDeleteModal(true);
            }}
          >
            <DeleteIcon width={38} height={38} />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <>
      <ConfirmationPop
        confirmation={showDeleteModal}
        setConfirmation={setShowDeleteModal}
        type={"delete"}
        confirmHandler={handleDeleteGoal}
      />
      <AddNewGoalPop
        showPopup={newGoalPopup?.show}
        closePopup={hideNewGoalPopup}
        data={newGoalPopup?.data}
        assessmentData={data}
        submitCallback={() => refetch()}
        clientType={clientType}
      />
      <section className="TreatmentPlan py-3 position-relative">
        <Container fluid>
          <Row>
            <Col lg="12" className="my-2">
              <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center">
                <li className="">
                  <Link
                    className="themeBlue fw-sbold"
                    style={{ textDecoration: "underline", fontSize: 14 }}
                    to={previousUrl || "/client/school/"}
                  >
                    Client
                  </Link>
                </li>
                <li className="">
                  <h6 className="m-0 fw-bold themeBlue" style={{ fontSize: 14 }}>
                    / Treatment Plan Setup
                  </h6>
                </li>
              </ul>
            </Col>
            {isLoading ? (
              <LoadingIndicator />
            ) : isError ? (
              <ErrorComponent />
            ) : (
              <>
                {(isFetching || deleteGoalLoading) && <LoadingOverlay />}
                <Col lg="12" className="my-2">
                  {/* <div className="text-end">
                    <Link className="fw-sbold themeClr" to="">
                      All Compoleted Goals
                    </Link>
                  </div> */}
                  <Row
                    className="p-2 align-items-center"
                    style={{ background: "#F8F8F9" }}
                  >
                    <Col lg="3" className="my-2">
                      <div className="d-flex align-items-center gap-10 mb-2">
                        <div
                          className="imgWrp flex-shrink-0 d-flex align-items-center justify-content-center rounded-circle"
                          style={{
                            height: 35,
                            width: 35,
                            background: "#DBDBDB",
                          }}
                        >
                          <h6 className="m-0 fw-bold">
                            {printNameInitials(data)}
                          </h6>
                        </div>
                        <div className="content">
                          <h6 className="m-0 fw-bold themeBlue">
                            {userFullNameReverse(data)}
                          </h6>
                        </div>
                      </div>
                    </Col>
                    <Col lg="2" className="my-2">
                      <div className="bg-white p-2 rounded">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          <span
                            className="icn me-1"
                            style={{ color: "#3DA0AA" }}
                          >
                            ■{" "}
                          </span>{" "}
                          DOB
                        </h6>
                        <p className="m-0 pt-2 themeBlue">
                          {dateFormat(data?.client_detail?.dob)}
                        </p>
                      </div>
                    </Col>

                    <Col lg="2" className="my-2">
                      <div className="bg-white p-2 rounded">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          <span
                            className="icn me-1"
                            style={{ color: "#3DA0AA" }}
                          >
                            ■{" "}
                          </span>{" "}
                          Grade
                        </h6>
                        <p className="m-0 pt-2 themeBlue">
                          Grade {data?.client_detail?.grade}
                        </p>
                      </div>
                    </Col>
                    {clientType == "school" && <Col lg="2" className="my-2">
                      <div className="bg-white p-2 rounded">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          <span
                            className="icn me-1"
                            style={{ color: "#3DA0AA" }}
                          >
                            ■{" "}
                          </span>{" "}
                          School
                        </h6>
                        <p className="m-0 pt-2 themeBlue">
                          {
                            data?.client_detail?.client_school_detail
                              ?.client_school?.name
                          }
                        </p>
                      </div>
                    </Col>}
                    <Col lg="2" className="my-2">
                      <div className="bg-white p-2 rounded">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          <span
                            className="icn me-1"
                            style={{ color: "#3DA0AA" }}
                          >
                            ■{" "}
                          </span>{" "}
                          {clientType == "school" ? "Teacher" : "Parent"}

                        </h6>
                        <p className="m-0 pt-2 themeBlue text-capitalize">
                          {
                            clientType == "school" ? userFullName(teacherDetails) : userFullName(parentDetails)
                          }
                        </p>
                      </div>
                    </Col>
                    <Col lg="12">
                      <ul className="list-unstyled ps-0 mb-0 d-flex align-items-center gap-10">
                        <li>
                          <div
                            className="btn d-flex align-items-center justify-content-center rounded-pill text-muted bg-white h-auto px-3 py-1"
                            style={{ borderColor: "#071E3E" }}
                          >
                            <p className="m-0 fw-bold" style={{ fontSize: 14 }}>
                              {caseDiscipline?.name}
                            </p>
                          </div>
                        </li>
                      </ul>
                    </Col>

                    {/* <Col lg="2" className="my-2">
                      <div className="bg-white p-2 rounded">
                        <h6
                          className="m-0 d-flex align-items-start themeBlue fw-bold"
                          style={{ fontSize: 13 }}
                        >
                          <span className="icn me-1" style={{ color: "#3DA0AA" }}>
                            ■{" "}
                          </span>{" "}
                          Teacher Tom Gonzales
                        </h6>
                        <p className="m-0 pt-2 themeBlue">Tom Gonzales</p>
                      </div>
                    </Col> */}
                  </Row>
                </Col>
                <Col lg="12" className="my-2">
                  <div className="d-flex align-items-center justify-content-between gap-10">
                    {!previousUrl ? <div className="left d-flex align-items-center gap-10">
                      {/* <span className="icn me-2">
                        <HeartIcon />
                      </span> */}
                      {editTreatmentName ? (
                        <input
                          type="text"
                          className={`form-control rounded-3 bg-white h-auto`}
                          value={treatmentName}
                          onChange={handleTreatmentNameChange}
                        ></input>
                      ) : (
                        <h6 className="fw-bold themeBlue m-0">
                          {treatmentName}
                        </h6>
                      )}
                      {editTreatmentName ? (
                        <Button
                          className="rounded-circle border-0 p-1"
                          variant="transparent"
                          onClick={() => setEditTreatmentName(false)}
                        >
                          <CheckIcon />
                        </Button>
                      ) : (
                        <Button
                          className="rounded-circle shadow border-0 p-0"
                          variant="transparent"
                          onClick={() => setEditTreatmentName(true)}
                        >
                          <EditCricleIcon />
                        </Button>
                      )}
                    </div> : <span></span>}
                    <div className="right">
                      <Button
                        onClick={() => {
                          openNewGoalPopup();
                        }}
                        className="d-flex align-items-center justify-content-center commonBtn"
                      >
                        <span className="icn me-2">
                          <PlusCircleIcon />
                        </span>{" "}
                        Add New Goals
                      </Button>
                    </div>
                  </div>
                </Col>
                <Col lg="12" className="my-2">
                  <TableLayout
                    showHeader={false}
                    data={assessmentGoals}
                    column={column}
                    noDataMsg="No goals found"
                  />
                  <div className="btnWrpper mt-3 d-flex gap-10">
                    <Button
                      style={{
                        background: "rgb(69, 163, 165)",
                        borderColor: "rgb(69, 163, 165)",
                      }}
                      onClick={previousUrl ? () => navigate(previousUrl) : onNavigateBack}
                      disabled={!!submitLoading}
                      className="d-flex align-items-center justify-content-center commonBtn fw-sbold"
                    >
                      Back
                    </Button>
                    {!previousUrl && <LoadingButton
                      // onClick={() =>
                      //   navigate("/client/treatment-plan/start-session/:a23423")
                      // }
                      onClick={handleSubmitStep}
                      className="d-flex align-items-center justify-content-center commonBtn"
                      isLoading={submitLoading}
                    >
                      Next
                    </LoadingButton>}
                  </div>
                </Col>
              </>
            )}
          </Row>
        </Container>
      </section>
    </>
  );
};

const newGoalPopupState = {
  show: false,
  data: null,
  editId: null,
};

export default ManageGoals;
